import React from 'react';
import pattern2 from '../assets/images/background/pattern-2.png';
// import pattern_16 from '../assets/images/background/pattern-16.png';
// import news_5 from '../assets/images/resource/news-5.jpg';
// import news_11 from '../assets/images/resource/news-11.jpg';
// import news_12 from '../assets/images/resource/news-12.jpg';
import feature_1 from '../assets/images/resource/feature-1.jpg';
import feature_2 from '../assets/images/resource/feature-1.jpg';
import { Link } from 'react-router-dom';
const ServiceHome = ({ }) => {
	return (
		<div>
			<section className="featured-section">
				<div className="auto-container">
					<div className="row clearfix">
						<div className="feature-block-two col-lg-6 col-md-12 col-sm-12">
							<div className="inner-box wow fadeInLeft" data-wow-delay="0ms" data-wow-duration="1500ms" style={{ backgroundImage: `url(${feature_1})` }}>
								<div className="number">100 +</div>
								<h4>Projects Across Many Countries</h4>
								<div className="text">We have worked with teams in India and outside India. Our work is simple and steady, and it helps brands run their day-to-day tasks with ease.</div>
							</div>
						</div>

						<div className="feature-block-two col-lg-6 col-md-12 col-sm-12">
							<div className="inner-box wow fadeInRight" data-wow-delay="0ms" data-wow-duration="1500ms" style={{ backgroundImage: `url(${feature_2})` }}>
								<div className="number">100 +</div>
								<h4>Happy Clients</h4>
								<div className="text">Many clients trust our team for web, software, and marketing work. They like our clear steps and fast help. We work with care on every project.</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<section className="services-section margin-top">
				<div className="pattern-layer" style={{ backgroundImage: `url(${pattern2})` }}>
				</div>
				<div className="auto-container">
					{/* <!-- Sec Title --> */}
					<div className="sec-title light centered">
						<div className="title">WHO WE ARE</div>
						{/* <h2>We deal with the aspects of <br /> professional IT Services</h2> */}
						<h2>SwiftMaze Technology Work on Many Parts of IT Services That Help You Grow</h2>
					</div>
					<div className="row clearfix">

						{/* <!-- Service Block --> */}
						<div className="service-block col-lg-4 col-md-6 col-sm-12">
							<Link to="/services/web-development/" className="service-link-wrap">
							<div className="inner-box">
								<div className="icon-box">
									<span className="icon flaticon-coding"></span>
								</div>
								<h5>Website Development</h5>
								<div className="text">We build clean and simple websites that work well on phones, tablets, and laptops. As a website development company in Modasa, we plan each page with care so your business looks clear online. The site loads fast and feels easy for your users. We guide you with content and setup so the full process stays smooth for you.</div>
								<span className="arrow flaticon-long-arrow-pointing-to-the-right"></span>
							</div>
 						</Link>
						</div>

						<div className="service-block col-lg-4 col-md-6 col-sm-12">
								<Link to="/services/software-development-modasa/" className="service-link-wrap">
							<div className="inner-box">
								<div className="icon-box">
									<span className="icon flaticon-laptop"></span>
								</div>
								<h5>Software Development</h5>
								<div className="text">Our team makes software that fits your daily work without making things hard. As a software development company in Modasa, we build tools that solve real problems and help your staff save time. Each feature stays simple so anyone can use it with ease. As your business grows, the software grows with you and keeps your work steady.</div>
								<span className="arrow flaticon-long-arrow-pointing-to-the-right"></span>
							</div>
						</Link>
						</div>

						<div className="service-block col-lg-4 col-md-6 col-sm-12">
							<Link to="/services/digital-marketing-modasa/" className="service-link-wrap">
							<div className="inner-box">
								<div className="icon-box">
									<span className="icon flaticon-responsive"></span>
								</div>
								<h5>Digital Marketing</h5>
								<div className="text">We help your business reach more people with clear SEO and ad plans. As a digital marketing agency in Modasa, we keep each step simple and easy to follow. Our team works on search results, social pages, and local reach so more people know your brand. You see steady growth in calls, leads, and daily interest.</div>
								<span className="arrow flaticon-long-arrow-pointing-to-the-right"></span>
							</div>
							</Link>
						</div>

						<div className="service-block col-lg-4 col-md-6 col-sm-12">
								<Link to="/services/mobile-app-development-modasa/" className="service-link-wrap">
							<div className="inner-box">
								<div className="icon-box">
									<span className="icon flaticon-monitor"></span>
								</div>
								<h5>Mobile App Development Modasa</h5>
								<div className="text">We create smooth mobile apps for Android and iOS that feel light and easy to use. Each screen has a simple flow so users do not feel confused. Our team guides you from planning to testing and keeps the work calm at every step. The final app supports your daily tasks and gives users a steady experience.</div>
								<span className="arrow flaticon-long-arrow-pointing-to-the-right"></span>
							</div>
							</Link>
						</div>
							<div className="service-block col-lg-4 col-md-6 col-sm-12">
								<Link to="/services/hire-chrome-extension-developer/" className="service-link-wrap">
							<div className="inner-box">
								<div className="icon-box">
									<span className="icon flaticon-coding"></span>
								</div>
								<h5>Hire Chrome Extension Developer</h5>
								<div className="text"> We build custom browser extensions that help you finish small tasks faster. These tools save time and keep your work simple. You can manage tasks, collect data, or run small actions with one click. The design stays clean so the tool feels natural while you work. It becomes a part of your routine without extra effort.</div>
								<span className="arrow flaticon-long-arrow-pointing-to-the-right"></span>
							</div>
							</Link>
						</div>

						<div className="service-block col-lg-4 col-md-6 col-sm-12">
							<Link to="/services/erp-development/" className="service-link-wrap">
							<div className="inner-box">
								<div className="icon-box">
									<span className="icon flaticon-laptop"></span>
								</div>
								<h5>ERP Systems</h5>
								<div className="text">Our ERP systems bring all your work into one place so your team can stay focused. You can track stock, sales, staff, and reports through simple screens. We help you shift from old methods to one clear system that feels easy from the first day. It keeps your business steady, organized, and ready for growth.</div>
								<span className="arrow flaticon-long-arrow-pointing-to-the-right"></span>
							</div>
							</Link>
						</div>

						<div className="service-block col-lg-4 col-md-6 col-sm-12">
							<Link to="/services/crm-development/" className="service-link-wrap">
							<div className="inner-box">
								<div className="icon-box">
									<span className="icon flaticon-dashboard"></span>
								</div>
								<h5>CRM System</h5>
								<div className="text">Our CRM systems help you manage leads, follow-ups, customer records, and team activity from one clear place. We keep the setup simple so your staff can track calls, tasks, and sales without confusion. A good CRM gives you better control, faster response, and stronger customer relationships as your business grows.</div>
								<span className="arrow flaticon-long-arrow-pointing-to-the-right"></span>
							</div>
							</Link>
						</div>

						<div className="service-block col-lg-4 col-md-6 col-sm-12">
							<Link to="/services/web-development/" className="service-link-wrap">
							<div className="inner-box">
								<div className="icon-box">
									<span className="icon flaticon-responsive"></span>
								</div>
								<h5>UI UX Design</h5>
								<div className="text">We design screens that feel clear and friendly for every user. Our team works on layouts, colors, and flow so the full journey stays smooth. We test the design with real use cases to make sure it works in daily life. Good design helps people stay longer on your app or site and builds trust in your brand.</div>
								<span className="arrow flaticon-long-arrow-pointing-to-the-right"></span>
							</div>
							</Link>
						</div>

						<div className="service-block col-lg-4 col-md-6 col-sm-12">
							<Link to="/training/web-designing-course-modasa/" className="service-link-wrap">
							<div className="inner-box">
								<div className="icon-box">
									<span className="icon flaticon-open-book"></span>
								</div>
								<h5>Practical IT Training</h5>
								<div className="text">We also guide students and freshers through practical IT training in Modasa. Our courses cover web designing, web development, and digital marketing with 90% practical learning, Generative AI support, and online or offline options for learners from Aravalli and nearby cities. This helps students build real skills with clear guidance.</div>
								<span className="arrow flaticon-long-arrow-pointing-to-the-right"></span>
							</div>
							</Link>
						</div>
						

					</div>
				</div>
			</section>
		</div>
	);
};

export default ServiceHome;
